import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { staggerContainer, staggerItem, fadeInUp } from '../../utils/animation';
import { CERTIFICATIONS } from '../../data/constants';
import { IconCheck, IconAward, IconGraduationCap, IconZap, IconCloud, IconCode, IconActivity } from '../ui/Icons';
import './Certifications.css';

const CERT_ICONS = [
  <IconZap       size={18} />,
  <IconActivity  size={18} />,
  <IconCloud     size={18} />,
  <IconCode      size={18} />,
  <IconAward     size={18} />,
];

export const Certifications: React.FC = () => {
  const { ref, inView } = useIntersectionObserver({ threshold: 0.08, triggerOnce: true });

  return (
    <section id="certifications" className="certs section" ref={ref}>
      <div className="container">
        <div className="section__header">
          <span className="section__subtitle">CREDENTIALS</span>
          <h2 className="section__title">Certifications</h2>
          <p className="section__description">
            Certified across the modern data and AI stack - Apache Spark, AWS, Vision Transformers, and Go.
          </p>
        </div>

        <motion.div
          className="certs__grid"
          variants={staggerContainer}
          initial="initial"
          animate={inView ? 'animate' : 'initial'}
        >
          {CERTIFICATIONS.map((cert, i) => (
            <motion.div
              key={i}
              className="cert__card"
              variants={staggerItem}
              whileHover={{ y: -4, borderColor: 'rgba(99,102,241,0.45)', transition: { duration: 0.2 } }}
            >
              <div className="cert__icon-wrap">
                {CERT_ICONS[i] ?? <IconAward size={18} />}
              </div>
              <div className="cert__info">
                <h4 className="cert__title">{cert.title}</h4>
                <p className="cert__issuer">{cert.issuer}</p>
              </div>
              <div className="cert__check">
                <IconCheck size={13} />
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Education */}
        <motion.div
          className="certs__edu"
          variants={fadeInUp}
          initial="initial"
          animate={inView ? 'animate' : 'initial'}
        >
          <div className="edu__icon">
            <IconGraduationCap size={22} />
          </div>
          <div>
            <h4 className="edu__degree">Bachelor of Technology - Computer Science</h4>
            <p className="edu__school">Asansol Engineering College (AEC) · 2015 – 2019</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
